import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import { Divider, Typography } from '@lyearn/ui';

import { FilterLabelProps } from './types';

function FilterLabel(props: FilterLabelProps) {
  const { label, className } = props;
  const { isMobile } = useScreen();

  if (!isMobile) {
    return null;
  }

  return (
    <>
      <Typography
        as="p"
        className={cn('p-20', className)}
        color="text-text-primary"
        variant="heading-s">
        {label}
      </Typography>
      <Divider color="border-interactive-border" />
    </>
  );
}

export default FilterLabel;
